var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "reporting-filters p-10 p-b-0" },
      [
        _c("ValidationObserver", {
          ref: "formValidation",
          attrs: { slim: "" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function({ invalid }) {
                return [
                  _c(
                    "form",
                    { attrs: { name: "reportingFilters" } },
                    [
                      !_vm.showSummary
                        ? _c("FilterCriteria", {
                            attrs: {
                              "is-full-width": "",
                              "available-tags": _vm.availableFilters,
                              "use-in-reporting-filters": "",
                              "values-for-reporting-filter":
                                _vm.valuesForFilter,
                              "form-name-for-user-settings":
                                _vm.formNameForUserSettings,
                              "event-category": _vm.eventCategory,
                              "quick-filters": _vm.quickFilters
                            },
                            model: {
                              value: _vm.filterCriteriaCopy,
                              callback: function($$v) {
                                _vm.filterCriteriaCopy = $$v
                              },
                              expression: "filterCriteriaCopy"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showSummary
                    ? _c("FilterCriteriaConciseSummary", {
                        staticClass: "clickable",
                        attrs: {
                          "filter-criteria": _vm.filterCriteriaCopy,
                          "available-tags": _vm.availableFilters,
                          "tag-id-to-text": _vm.tagIdToText
                        },
                        on: {
                          click: _vm.toggleSummary,
                          deleteOrCriteria: _vm.deleteOrCriteria
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isFilterCriteriaEmpty
                    ? _c(
                        "div",
                        {
                          staticClass: "clearfix p-b-10",
                          class: {
                            "m-t-5": _vm.showSummary,
                            "m-t-15": !_vm.showSummary
                          }
                        },
                        [
                          !_vm.showSummary
                            ? _c("btn", {
                                directives: [
                                  {
                                    name: "t",
                                    rawName: "v-t",
                                    value: "APPLY_FILTERS",
                                    expression: "'APPLY_FILTERS'"
                                  }
                                ],
                                attrs: {
                                  type: "success",
                                  size: "sm",
                                  disabled: invalid
                                },
                                on: { click: _vm.applyFilters }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showSummary
                            ? _c("btn", {
                                directives: [
                                  {
                                    name: "t",
                                    rawName: "v-t",
                                    value: "EDIT_FILTERS",
                                    expression: "'EDIT_FILTERS'"
                                  }
                                ],
                                attrs: { type: "primary", size: "sm" },
                                on: { click: _vm.toggleSummary }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("btn", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "CLEAR_FILTERS",
                                expression: "'CLEAR_FILTERS'"
                              }
                            ],
                            staticClass: "m-l-10",
                            attrs: { type: "danger", size: "sm" },
                            on: { click: _vm.clearFilters }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              }
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }